import { useState, useRef, useEffect } from "react";
import RequestWorker from "./requestWorker";
import { Turnstile } from '@marsidev/react-turnstile';
import { jsPDF } from "jspdf";
import { AsYouType, isValidPhoneNumber } from "libphonenumber-js";

function getBrandKey() {
  const hostname = window.location.hostname;
  const subdomain = hostname.split(".")[0];
  const params = new URLSearchParams(window.location.search);
  const override = params.get("brand");

  if (override) return override;
  return subdomain || "upcr";
}

function trackVirtualEvent(virtualPath) {
  const restorePath = window.location.pathname;
  window.history.pushState({}, "", virtualPath);
  window.history.pushState({}, "", restorePath);
}

const UPCR_LOGO_GHOST = "data:image/png;base64,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";



// ─── Styles ───────────────────────────────────────────────────────────────────
const css = `
  @import url('https://fonts.googleapis.com/css2?family=Noto+Sans:wght@300;400;500;600;700&family=Dancing+Script:wght@600&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  :root {
    --brand: #1B9046;
    --brand-dark: #146634;
    --brand-light: #e8f5ee;
    --brand-mid: #a8d9bc;
    --white: #ffffff;
    --gray-50: #F7F8F5;
    --gray-100: #EDEEE9;
    --gray-200: #D8D9D3;
    --gray-300: #C4C5BF;
    --gray-500: #888780;
    --gray-700: #444441;
    --gray-900: #1A1A18;
    --red: #c0392b;
    --red-bg: #fdf0ef;
    --red-border: #e5b4b1;
    --shadow-lg: 0 8px 40px rgba(27,144,70,0.13);
    --font: 'Noto Sans', sans-serif;
  }
  html, body { font-family: var(--font); background: var(--gray-50); color: var(--gray-900); min-height: 100vh; }
  body { padding: 1.5rem 1rem 4rem; }
  .app-wrap { max-width: 620px; margin: 0 auto; }

  /* ── Header ── */
  .header {
    background: var(--brand);
    border-radius: 16px 16px 0 0;
    padding: 1.75rem 2rem 1.5rem;
    position: relative;
    overflow: hidden;
  }
  .header-ghost {
    position: absolute;
    right: -10px; top: 0; bottom: 0;
    width: 320px;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    opacity: 0.22;
    pointer-events: none;
  }
  .header-inner { position: relative; z-index: 1; }
  .brand-name {
    font-size: 26px; font-weight: 700; color: white;
    letter-spacing: -0.3px; line-height: 1.1;
  }
  .brand-tagline {
    font-size: 9.5px; color: rgba(255,255,255,0.75);
    font-weight: 600; margin-top: 3px; line-height: 1.3;
    text-transform: uppercase; letter-spacing: 0.08em;
  }
  .header-badge {
    display: inline-block; background: rgba(255,255,255,0.18);
    border: 1px solid rgba(255,255,255,0.35); border-radius: 20px;
    font-size: 9.5px; font-weight: 700; letter-spacing: 0.08em;
    color: white; padding: 3px 10px; text-transform: uppercase; margin-top: 8px;
  }

  /* ── Card ── */
  .card {
    background: var(--white);
    box-shadow: var(--shadow-lg);
    border-radius: 0 0 16px 16px;
    padding: 1.75rem 1.75rem 2rem;
  }






  /* ── Back Button ── */
  .btn-back {
    display: inline-flex; align-items: center; gap: 6px;
    background: none; border: 1.5px solid var(--gray-200);
    border-radius: 8px; padding: 8px 16px;
    font-size: 12px; font-weight: 600; color: var(--gray-500);
    font-family: var(--font); cursor: pointer;
    transition: border-color 0.15s, color 0.15s, background 0.15s;
    margin-top: 0.75rem;
  }
  .btn-back:hover { border-color: var(--gray-300); color: var(--gray-700); background: var(--gray-50); }
  .btn-back-wrap { display: flex; justify-content: flex-start; }

  /* ── Mobile vs Desktop layout ── */
  /* Desktop: card has generous padding, max-width constrained */
  @media (min-width: 641px) {
    .app-wrap { max-width: 640px; }
    .card { padding: 2rem 2.25rem 2.5rem; }
    .header { padding: 2rem 2.25rem 1.75rem; }
    .field-row { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
  }
  /* Mobile: full-width, tighter padding, single-column fields */
  @media (max-width: 640px) {
    body { padding: 0 0 3rem; }
    .app-wrap { max-width: 100%; margin: 0; }
    .header { border-radius: 0; padding: 1.1rem 1rem 0.9rem; }
    .header-ghost { width: 160px; opacity: 0.18; }
    .brand-name { font-size: 22px; }
    .brand-tagline { font-size: 8.5px; }
    .header-badge { font-size: 8.5px; padding: 2px 8px; }
    .card { border-radius: 0; padding: 1.1rem 1rem 1.75rem; box-shadow: none; }
    .field-row { display: flex; flex-direction: column; gap: 12px; }
    .begin-box { padding: 1rem; }
    .begin-title { font-size: 14px; }
    .begin-sub { font-size: 12px; }
    .info-box { font-size: 12.5px; }
    .info-box-gold { font-size: 12.5px; }
    .btn-primary { font-size: 14px; padding: 13px; }
    .summary-label { font-size: 10px; }
    .summary-value { font-size: 12px; }
    .response-label { font-size: 12.5px; }
    .sig-cursive { font-size: 20px; }
    .sig-attest-text { font-size: 12px; }
    .sig-attest-warning { font-size: 11px; }
    .steps { padding: 0 0 1rem; }
    .step-label { font-size: 9px; }
    .section-title { font-size: 9.5px; }
    .section-title-lg { font-size: 11px; }
    .recaptcha-mock { transform: scale(0.92); transform-origin: left center; }
  }

  /* ── Property Cards ── */
  .property-cards {
    display: flex; flex-direction: column; gap: 10px;
    margin-bottom: 1.25rem;
  }
  .property-card {
    border: 1.5px solid var(--brand-mid);
    border-radius: 10px;
    padding: 0.85rem 1rem;
    background: var(--brand-light);
  }
  .property-total-row {
    display: flex; justify-content: space-between; align-items: center;
    margin-top: 10px; padding: 10px 14px;
    background: var(--brand); border-radius: 8px;
  }
  .property-total-label {
    font-size: 11px; font-weight: 700; letter-spacing: 0.06em;
    text-transform: uppercase; color: white;
  }
  .property-total-value {
    font-size: 15px; font-weight: 700; color: white;
  }
  .property-card-header {
    font-size: 9.5px; font-weight: 700; letter-spacing: 0.08em;
    text-transform: uppercase; color: var(--brand-dark);
    margin-bottom: 0.6rem; padding-bottom: 5px;
    border-bottom: 1px solid var(--brand-mid);
  }
  /* ── Confirm Checkbox Row ── */
  .confirm-check-row {
    display: flex; align-items: flex-start; gap: 12px;
    padding: 13px 15px; border-radius: 10px;
    border: 1.5px solid var(--gray-200);
    background: var(--gray-50); cursor: pointer;
    transition: border-color 0.15s, background 0.15s;
    user-select: none; margin-bottom: 0.25rem;
  }
  .confirm-check-row:hover { border-color: var(--brand-mid); background: var(--brand-light); }
  .confirm-check-row.error { border-color: var(--red); background: var(--red-bg); }
  .confirm-checkbox {
    width: 18px; height: 18px; border-radius: 4px;
    border: 2px solid var(--gray-300); background: white;
    flex-shrink: 0; margin-top: 1px;
    display: flex; align-items: center; justify-content: center;
    font-size: 12px; font-weight: 700; color: white;
    transition: border-color 0.15s, background 0.15s;
  }
  .confirm-checkbox.checked { border-color: var(--brand); background: var(--brand); }
  .confirm-check-label {
    font-size: 13px; font-weight: 500; color: var(--gray-900); line-height: 1.5;
  }
  /* ── Response Options ── */
  .response-options {
    display: flex; flex-direction: column; gap: 10px;
    margin-bottom: 0.5rem;
  }
  .response-option {
    display: flex; align-items: flex-start; gap: 12px;
    padding: 13px 15px; border-radius: 10px;
    border: 1.5px solid var(--gray-200);
    background: var(--gray-50); cursor: pointer;
    transition: border-color 0.15s, background 0.15s;
    user-select: none;
  }
  .response-option:hover { border-color: var(--brand-mid); background: var(--brand-light); }
  .response-option.selected { border-color: var(--brand); background: var(--brand-light); }
  .response-radio {
    width: 18px; height: 18px; border-radius: 50%;
    border: 2px solid var(--gray-300); background: white;
    flex-shrink: 0; margin-top: 1px;
    transition: border-color 0.15s, background 0.15s;
    position: relative;
  }
  .response-radio.selected { border-color: var(--brand); background: var(--brand); }
  .response-radio.selected::after {
    content: ""; position: absolute;
    top: 3px; left: 3px;
    width: 8px; height: 8px;
    border-radius: 50%; background: white;
  }
  .response-label {
    font-size: 13px; font-weight: 500; color: var(--gray-900); line-height: 1.5;
  }
  /* ── Signature / Attestation ── */
  .sig-attest-box {
    background: #f5f7fa;
    border: 1.5px solid #c2cad6;
    border-radius: 12px;
    padding: 1.25rem 1.25rem 1rem;
    margin-bottom: 1.25rem;
  }
  .sig-attest-text {
    font-size: 12.5px; color: var(--gray-700); line-height: 1.65;
    margin-bottom: 0.85rem;
  }
  .sig-attest-warning {
    font-size: 11.5px; color: #7a2c2c;
    background: #fdf0ef; border: 1px solid #e5b4b1;
    border-radius: 8px; padding: 0.6rem 0.85rem;
    line-height: 1.55; margin-bottom: 1rem;
  }
  .sig-label {
    font-size: 11px; font-weight: 700; color: var(--gray-700);
    letter-spacing: 0.01em; display: block; margin-bottom: 5px;
  }
  .sig-input {
    width: 100%; border: 1.5px solid var(--gray-200);
    border-radius: 8px; padding: 9px 14px;
    font-size: 15px; font-family: var(--font);
    color: var(--gray-900); background: white;
    outline: none; transition: border-color 0.15s, box-shadow 0.15s;
  }
  .sig-input:focus { border-color: #2a4a7f; box-shadow: 0 0 0 3px rgba(42,74,127,0.10); }
  .sig-input.error { border-color: var(--red); background: var(--red-bg); }
  .sig-field-wrap { margin-bottom: 0.75rem; }
  .comments-input {
  width: 100%; border: 1.5px solid var(--gray-200);
  border-radius: 8px; padding: 10px 12px;
  font-size: 13.5px; font-family: var(--font);
  color: var(--gray-900); background: white;
  outline: none; resize: vertical; min-height: 80px;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.comments-input:focus { border-color: var(--brand); box-shadow: 0 0 0 3px rgba(27,144,70,0.12); }
  .sig-preview {
    display: flex; align-items: baseline; justify-content: space-between;
    border-top: 1.5px solid #c2cad6; padding-top: 0.65rem; margin-top: 0.25rem;
    gap: 1rem;
  }
  .sig-cursive {
    font-family: "Dancing Script", "Brush Script MT", cursive;
    font-size: 24px; color: #1a2f52; letter-spacing: 0.5px;
    flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  }
  .sig-date {
    font-size: 11px; color: var(--gray-500); white-space: nowrap; flex-shrink: 0;
  }

  .response-divider {
  display: flex; align-items: center;
  margin: 1.25rem 0;
  color: var(--gray-500); font-size: 11px; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.06em;
}
.response-divider::before,
.response-divider::after {
  content: ""; flex: 1;
  border-bottom: 1.5px solid var(--gray-200);
}
.response-divider span { padding: 0 12px; }

  /* ── Steps ── */
  .steps { display: flex; align-items: flex-start; margin-bottom: 1.5rem; }
  .step-col { display: flex; flex-direction: column; align-items: center; }
  .step-dot {
    width: 28px; height: 28px; border-radius: 50%;
    border: 2px solid var(--gray-200); background: white;
    color: var(--gray-300); font-size: 11px; font-weight: 700;
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0; transition: all 0.2s;
  }
  .step-dot.active { border-color: var(--brand); background: var(--brand); color: white; }
  .step-dot.done { border-color: var(--brand); background: var(--brand-light); color: var(--brand); }
  .step-line { flex: 1; height: 2px; background: var(--gray-200); margin-top: 13px; transition: background 0.2s; }
  .step-line.done { background: var(--brand-mid); }
  .step-label { font-size: 9.5px; font-weight: 600; color: var(--gray-500); text-transform: uppercase; letter-spacing: 0.05em; margin-top: 4px; white-space: nowrap; }
  .step-label.active { color: var(--brand); }

  /* ── Section title ── */
  .section-title {
    font-size: 10px; font-weight: 700; letter-spacing: 0.09em;
    text-transform: uppercase; color: var(--brand);
    margin-bottom: 0.85rem; padding-bottom: 5px;
    border-bottom: 1.5px solid var(--brand-light);
  }
  .section-title-lg {
    font-size: 12.5px; font-weight: 700; letter-spacing: 0.07em;
    text-transform: uppercase; color: var(--brand);
    margin-bottom: 0.85rem; padding-bottom: 5px;
    border-bottom: 1.5px solid var(--brand-light);
  }

  /* ── Form fields ── */
  .field { margin-bottom: 1rem; }
  .field label { display: block; font-size: 11px; font-weight: 700; color: var(--gray-700); margin-bottom: 5px; letter-spacing: 0.02em; }
  .field input {
    width: 100%; padding: 10px 12px; border: 1.5px solid var(--gray-200);
    border-radius: 8px; font-size: 14px; font-family: var(--font);
    color: var(--gray-900); background: white; outline: none;
    transition: border-color 0.15s, box-shadow 0.15s;
  }
  .field input:focus { border-color: var(--brand); box-shadow: 0 0 0 3px rgba(27,144,70,0.12); }
  .field input.error { border-color: var(--red); box-shadow: 0 0 0 3px rgba(192,57,43,0.1); }
  .field-hint { font-size: 10.5px; color: var(--gray-500); margin-top: 4px; }
  .field-error { font-size: 10.5px; color: var(--red); margin-top: 4px; font-weight: 600; }
  .field-row { display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem; }
  @media (max-width: 420px) { .field-row { grid-template-columns: 1fr; } }

  /* ── Buttons ── */
  .btn-primary {
    width: 100%; padding: 12px 20px; background: var(--brand); color: white;
    border: none; border-radius: 9px; font-size: 14px; font-weight: 700;
    font-family: var(--font); cursor: pointer;
    transition: background 0.15s, transform 0.1s; letter-spacing: 0.01em;
  }
  .btn-primary:hover { background: var(--brand-dark); }
  .btn-primary:active { transform: scale(0.98); }
  .btn-primary:disabled { background: var(--gray-300); cursor: not-allowed; transform: none; }

  /* ── Info boxes ── */
  .info-box {
    background: var(--brand-light); border: 1.5px solid var(--brand-mid);
    border-radius: 10px; padding: 1rem 1.1rem; margin-bottom: 1.25rem;
    font-size: 13px; color: var(--gray-900); line-height: 1.55;
  }
  .info-box strong { color: var(--brand-dark); }
  .info-box-gold {
    background: #fff8e6; border: 1.5px solid #e5c66a;
    border-radius: 10px; padding: 1rem 1.1rem; margin-bottom: 1.25rem;
    font-size: 13px; color: var(--gray-900); line-height: 1.55;
  }
  .info-box-gold strong { color: #8a6400; }

  /* ── Alerts ── */
  .alert {
    padding: 10px 12px; border-radius: 8px; font-size: 12px;
    margin-bottom: 1rem; display: flex; align-items: flex-start;
    gap: 8px; line-height: 1.4;
  }
  .alert-error { background: var(--red-bg); border: 1px solid var(--red-border); color: #7a1a14; }
  .alert-success { background: var(--brand-light); border: 1px solid var(--brand-mid); color: var(--brand-dark); }
  .alert-info { background: #e8f1fb; border: 1px solid #a8c4e8; color: #1a3a6b; }
  .alert-icon { font-size: 14px; flex-shrink: 0; margin-top: 1px; }

  /* ── reCAPTCHA mock ── */
  .recaptcha-mock {
    border: 1.5px solid var(--gray-200); border-radius: 8px;
    padding: 12px 14px; display: flex; align-items: center; gap: 12px;
    background: #f9f9f9; margin-bottom: 1rem; user-select: none;
    cursor: pointer; transition: border-color 0.15s;
  }
  .recaptcha-mock:hover { border-color: var(--brand-mid); }
  .recaptcha-mock.checked { border-color: var(--brand); background: var(--brand-light); }
  .rc-checkbox {
    width: 22px; height: 22px; border: 2px solid var(--gray-300);
    border-radius: 3px; background: white; display: flex;
    align-items: center; justify-content: center; flex-shrink: 0;
    font-size: 14px; transition: all 0.15s;
  }
  .rc-checkbox.checked { background: var(--brand); border-color: var(--brand); color: white; }
  .rc-label { font-size: 13px; font-weight: 500; color: var(--gray-700); flex: 1; }
  .rc-badge { font-size: 8px; text-align: right; color: var(--gray-300); line-height: 1.3; }

/* ── What You Need ── */
.what-you-need {
  margin-top: 1rem;
  padding: 0.85rem 1rem;
  background: var(--gray-50);
  border: 1.5px solid var(--gray-200);
  border-radius: 10px;
}
.what-you-need-title {
  font-size: 10px; font-weight: 700; letter-spacing: 0.08em;
  text-transform: uppercase; color: var(--gray-500);
  margin-bottom: 0.5rem;
}
.what-you-need-list {
  margin: 0; padding-left: 1.25rem;
  display: flex; flex-direction: column; gap: 5px;
}
.what-you-need-list li {
  font-size: 13px; color: var(--gray-700); line-height: 1.4;
}

/* ── File Upload ── */
.file-upload-wrap { position: relative; }
.file-upload-input {
  position: absolute; width: 1px; height: 1px;
  padding: 0; margin: -1px; overflow: hidden;
  clip: rect(0,0,0,0); white-space: nowrap; border: 0;
}



.file-upload-btn {
  position: relative;
  display: flex; align-items: center; justify-content: center;
  background: var(--file-upload-bg, var(--brand-light));
  border: 1.5px dashed var(--file-upload-border, var(--brand-mid));
  border-radius: 10px; padding: 18px 16px;
  font-size: 13.5px; font-weight: 600;
  color: var(--file-upload-text, var(--brand-dark));
  font-family: var(--font); cursor: pointer;
  transition: border-color 0.15s, background 0.15s, transform 0.1s;
  width: 100%;
  text-align: center;
}
.file-upload-icon {
  position: absolute;
  left: 16px; top: 50%;
  transform: translateY(-50%);
  width: 32px; height: 32px;
}
.file-upload-btn:hover, .file-upload-btn:active {
  border-color: var(--file-upload-hover-border, var(--brand));
  background: var(--file-upload-hover-bg, #dcf0e5);
}
.file-upload-btn:active { transform: scale(0.99); }
.file-upload-btn.required {
  background: var(--file-upload-bg, var(--brand));
  border: 1.5px solid var(--file-upload-border, var(--brand));
  color: var(--file-upload-text, white);
}
.file-upload-btn.required:hover, .file-upload-btn.required:active {
  background: var(--file-upload-hover-bg, var(--brand-dark));
  border-color: var(--file-upload-hover-border, var(--brand-dark));
}
.file-upload-icon {
  width: 32px; height: 32px; flex-shrink: 0;
  display: block;
}
.file-upload-filename {
  font-size: 12px; color: var(--gray-700); margin-top: 8px;
  display: flex; align-items: center; gap: 6px;
  background: var(--gray-50); border: 1px solid var(--gray-200);
  border-radius: 8px; padding: 8px 10px;
}


  /* ── Begin box ── */
  .begin-box {
    border: 2px solid var(--brand-mid); border-radius: 12px;
    padding: 1.25rem 1.35rem; background: var(--brand-light);
    cursor: pointer; transition: all 0.15s;
    display: flex; align-items: center; gap: 14px;
  }
  .begin-box:hover { border-color: var(--brand); background: #dcf0e5; }
  .begin-icon { font-size: 26px; flex-shrink: 0; }
  .begin-title { font-size: 14px; font-weight: 700; color: var(--brand-dark); margin-bottom: 2px; }
  .begin-sub { font-size: 12px; color: var(--gray-700); line-height: 1.4; }

  /* ── Summary ── */
  .summary-box { border: 1.5px solid var(--gray-200); border-radius: 10px; padding: 0.85rem 1rem; margin-bottom: 1.25rem; }
  .summary-row {
    display: flex; justify-content: space-between; align-items: flex-start;
    padding: 8px 0; border-bottom: 1px solid var(--gray-100); font-size: 13px;
  }
  .summary-row:last-child { border-bottom: none; }
  .summary-label { color: var(--gray-500); font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; }
  .summary-value { color: var(--gray-900); font-weight: 600; text-align: right; max-width: 60%; }

  /* ── Success ── */
  /* ── Success checkmark animation ── */
  .success-check-wrap {
    display: flex; flex-direction: column; align-items: center;
    margin-bottom: 1.25rem; gap: 0.85rem;
  }
  .check-bubble {
    width: 72px; height: 72px; border-radius: 50%;
    background: var(--brand); display: flex; align-items: center; justify-content: center;
    animation: bubblePop 0.45s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
    opacity: 0; transform: scale(0.3);
  }
  @keyframes bubblePop {
    0%   { opacity: 0; transform: scale(0.3); }
    60%  { opacity: 1; transform: scale(1.12); }
    80%  { transform: scale(0.95); }
    100% { opacity: 1; transform: scale(1); }
  }
  .check-svg { width: 36px; height: 36px; }
  .check-path {
    stroke: white; stroke-width: 3.5; stroke-linecap: round; stroke-linejoin: round;
    fill: none;
    stroke-dasharray: 50;
    stroke-dashoffset: 50;
    animation: drawCheck 0.38s ease-out 0.32s forwards;
  }
  @keyframes drawCheck {
    to { stroke-dashoffset: 0; }
  }
  .success-logo-small {
    width: 72px; height: auto; display: block;
    animation: fadeSlideUp 0.4s ease 0.55s both;
  }
  @keyframes fadeSlideUp {
    from { opacity: 0; transform: translateY(6px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .success-title {
    text-align: center; font-size: 19px; font-weight: 700;
    color: var(--brand-dark); margin-bottom: 0.4rem;
    animation: fadeSlideUp 0.4s ease 0.65s both;
  }
  .success-sub {
    text-align: center; font-size: 13px; color: var(--gray-700); line-height: 1.5; margin-bottom: 1.5rem;
    animation: fadeSlideUp 0.4s ease 0.75s both;
  }
  .ref-pill {
    background: var(--brand-light); border: 1.5px solid var(--brand-mid);
    border-radius: 8px; padding: 10px 14px; text-align: center;
    font-size: 13px; font-weight: 700; color: var(--brand-dark);
    margin-bottom: 1.5rem; letter-spacing: 0.04em;
  }

  /* ── Spinner ── */
  .spinner {
    display: inline-block; width: 15px; height: 15px;
    border: 2.5px solid rgba(255,255,255,0.35);
    border-top-color: white; border-radius: 50%;
    animation: spin 0.7s linear infinite;
    vertical-align: middle; margin-right: 6px;
  }
  @keyframes spin { to { transform: rotate(360deg); } }

  hr { border: none; border-top: 1.5px solid var(--gray-100); margin: 1.25rem 0; }
  .footer-note { font-size: 11px; color: var(--gray-500); text-align: center; margin-top: 1.25rem; line-height: 1.5; }
`;



// ─── API functions ────────────────────────────────────────────────────────────

async function verifyClaim(claimId, amount, name, worker, cf_turnstile) {
  const key = claimId.trim().toUpperCase();
  const modulePrefix = key.slice(0, 2); 
  //console.log('cf-token: ', cf_turnstile);

  worker.setModulePrefix(modulePrefix);
  
  const ddlAgent = {
    letter_id:   key,
    cash_amount: amount.trim(),
    last_name:   name.trim().toLowerCase(),
  };
  const params = { letter_id: key, verbosity: "info" };

  try {
    const data = await worker.apiRequest("properties", "GET", null, params, null, null, ddlAgent, cf_turnstile);
    console.log("[UPCR] Properties response:", data);

    if (!data || data.error || !Array.isArray(data) || data.length === 0) {
      return { ok: false, message: "Letter ID not found in our system. Please verify the ID on your letter and try again." };
    }

    const record = data[0];

    // Block if already responded
if (record.ddl_response && typeof record.ddl_response === "string" && record.ddl_response.trim().toLowerCase() !== "no response") {
      return {
        ok: false,
        message: "A response has already been recorded for this Letter ID. If you believe this is an error, contact UPCR LLC at (678) 855-6185.",
      };
    }

    return {
      ok:             true,
      holderName:     record.full_name,
      fullName:       record.full_name,
      lastName:       name,
      claimId:        key,
      address:        record.full_address.replaceAll("\n", " "),
      company:        record.company_name,
      properties: data.map(p => ({
        id:                 p.id,
        letter_id:          key,
        issue_date:         p.issue_date || "",
        amount:             p.cash_amount || "0.00",
        account_number:     p.account_number || "",
        transaction_number: p.transaction_number || "",
        description:        p.description || "",
      })),
    };

  } catch (err) {

    if (!err.data) {
      console.error("[UPCR] Verify error:", err);
      trackVirtualEvent("/error/verify/network-error");
      return { ok: false, message: "Unable to process this request. Please try again." };
    }

    console.error("[UPCR] Verify error:", err.data);

    switch(err.data.detail) {
      case "DDL is not available for updates":
        trackVirtualEvent("/error/verify/already-responded");
        return { ok: false, message: "A response has already been recorded for this Letter ID. If you believe this is an error, contact UPCR LLC at (678) 855-6185." };
      case "Invalid Letter ID":
        trackVirtualEvent("/error/verify/invalid-letter-id");
        return { ok: false, message: "Letter ID not found in our system. Please verify the ID on your letter and try again." };
      case "Invalid Turnstile":
        trackVirtualEvent("/error/verify/invalid-turnstile");
        return { ok: false, message: "Invalid or duplicate validation token. Please refresh your browser and try again." };
      case "ClaimUP Disabled":
        trackVirtualEvent("/error/verify/claimup-disabled");
        return { ok: false, message: "You cannot process this claim with ClaimUP. Please contact UPCR LLC at (678) 855-6185." };
      case "Claim Expired":
        trackVirtualEvent("/error/verify/deadline-expired");
        return { ok: false, message: "The deadline to submit your claim has passed. Please contact UPCR LLC at (678) 855-6185." };
      case "Missing DDL Authentication Turnstile":
        trackVirtualEvent("/error/verify/missing-turnstile");
        return { ok: false, message: "Invalid or duplicate validation token. Please refresh your browser and try again." };        
      default:
        trackVirtualEvent("/error/verify/records-mismatch");
        return { ok: false, message: "The information entered does not match our records. Please check your letter and try again." };
    }
    
  }
}

async function submitClaim(payload, worker, cf_turnstile) {
  const ref = "UPCR-" + Math.random().toString(36).toUpperCase().slice(2, 8);
 console.log("[UPCR] Submitting claim:", payload,);
  const responseLabels = {
    confirmed:      "ClaimUP",
    update_address: "ClaimUP",
    not_holder:     "Not Owner",
    not_owed:       "Not Owed",
  };

  const today = new Date().toISOString().split("T")[0];

  const ddlAgent = {
    letter_id:   payload.claimId,
    cash_amount: payload.enteredAmount || "0.00",
    last_name: payload.lastName.trim().toLowerCase(),
  };
console.log("[UPCR] PUT ddlAgent:", ddlAgent);
  const formData = new FormData();
  formData.append("letter_id",         payload.claimId);
  formData.append("ddl_response",      responseLabels[payload.responseChoice] || payload.responseChoice);
  formData.append("ddl_response_date", today);
  formData.append("owner_email",       payload.email || "");
  formData.append("owner_phone",       payload.phone || "");

  // Build ddl_notes
  const noteParts = [];
  if (payload.phone) noteParts.push("Phone: " + payload.phone);
  if (payload.email) noteParts.push("Email: " + payload.email);
  if (payload.updatedAddress) {
    const addrParts = [
      payload.updatedAddress.line1,
      payload.updatedAddress.line2,
      payload.updatedAddress.line3,
      payload.updatedAddress.city,
      payload.updatedAddress.state,
      payload.updatedAddress.zip,
      payload.updatedAddress.country !== "United States" ? payload.updatedAddress.country : "",
    ].filter(Boolean).join(", ");
    noteParts.push("Owner Updated Address: " + addrParts);
    formData.append("owner_address", addrParts);
  }
  if (payload.comments) {
    noteParts.push("Comments: " + payload.comments);
    formData.append("owner_comments", payload.comments);
  }
  formData.append("ddl_notes", noteParts.join(" | "));



  // PDF and Image blob if provided
  if (payload.pdfBlob) formData.append("files", payload.pdfBlob, "Claim Submission: " + payload.claimId + ".pdf");
if (payload.letterImage) {
  const ext = payload.letterImage.name.split(".").pop();
  formData.append("files", payload.letterImage, "Letter Image: " + payload.claimId + "." + ext);
}
  try {
    const data = await worker.apiRequest("update-ddlresponse", "PUT", formData, null, null, null, ddlAgent, cf_turnstile);

    console.log("data: ",data)

    if (!data || data.error) {
      trackVirtualEvent("/error/submit/generic-failure");
      return { ok: false, message: "Submission failed. Please try again or contact support." };
    }

    return { ok: true, referenceNumber: data.reference_number || data.ref || ref };

  } catch (err) {
    if (!err.data) {
      console.error("[UPCR] Verify error:", err);
      trackVirtualEvent("/error/submit/network-error");
      return { ok: false, message: "Unable to process this request. Please try again." };
    }

    console.error("[UPCR] Verify error:", err.data);

    switch(err.data.detail) {
      case "DDL is not available for updates":
        trackVirtualEvent("/error/submit/already-responded");
        return { ok: false, message: "A response has already been recorded for this Letter ID. If you believe this is an error, contact UPCR LLC at (678) 855-6185." };
      case "Invalid Letter ID":
        trackVirtualEvent("/error/submit/invalid-letter-id");
        return { ok: false, message: "Letter ID not found in our system. Please verify the ID on your letter and try again." };
      case "Invalid Turnstile":
        trackVirtualEvent("/error/submit/invalid-turnstile");
        return { ok: false, message: "Invalid or duplicate validation token. Please refresh your browser and try again." };
      case "ClaimUP Disabled":
        trackVirtualEvent("/error/submit/claimup-disabled");
        return { ok: false, message: "You cannot process this claim with ClaimUP. Please contact UPCR LLC at (678) 855-6185." };
      case "Claim Expired":
        trackVirtualEvent("/error/submit/deadline-expired");
        return { ok: false, message: "The deadline to submit your claim has passed. Please contact UPCR LLC at (678) 855-6185." };
      default:
        trackVirtualEvent("/error/submit/records-mismatch");
        return { ok: false, message: "The information entered does not match our records. Please check your letter and try again." };
    }
  }
}




// ─── Step Indicator ───────────────────────────────────────────────────────────
function StepIndicator({ current }) {
  const steps = ["Welcome", "Verify", "Confirm"];
  return (
    <div className="steps">
      {steps.map((label, i) => {
        const num = i + 1;
        const isDone = num < current;
        const isActive = num === current;
        return (
          <div key={i} style={{ display: "flex", alignItems: "flex-start", flex: i < steps.length - 1 ? 1 : "none" }}>
            <div className="step-col">
              <div className={`step-dot${isActive ? " active" : isDone ? " done" : ""}`}>
                {isDone ? "✓" : num}
              </div>
              <div className={`step-label${isActive ? " active" : ""}`}>{label}</div>
            </div>
            {i < steps.length - 1 && (
              <div className={`step-line${isDone || isActive ? " done" : ""}`} />
            )}
          </div>
        );
      })}
    </div>
  );
}

// ─── Welcome Screen ───────────────────────────────────────────────────────────
function WelcomeScreen({ onBegin, brand }) {
  return (
    <>
      <StepIndicator current={1} />
      <div className="section-title-lg">About This Notice</div>
      <div className="info-box">
        <strong>Why did I receive a letter?</strong>
        <br /><br />
        <span dangerouslySetInnerHTML={{ __html: brand.config.welcomeBody }} /> <strong>{brand.config.phone}</strong>.
      </div>

      <div className="info-box-gold">
        <strong>⚠ Important Deadline</strong>
        <br />
        Responses must be received before the response date listed on your letter. Failing to respond may result in the property being transferred to the state.
      </div>

      <div className="section-title-lg">Begin Your Response</div>
      <button className="btn-primary" onClick={onBegin}>
        Start Your Claim →
      </button>
      <div className="what-you-need">
        <div className="what-you-need-title">What you'll need</div>
        <ul className="what-you-need-list">
          <li>Your <strong>Letter ID</strong> from the letter you received</li>
          <li>A <strong>dollar amount</strong> listed on your letter</li>
          <li>Your <strong>last name</strong></li>
          <li>A valid <strong>phone number</strong> and <strong>email address</strong></li>
        </ul>
      </div>

      <p className="footer-note" dangerouslySetInnerHTML={{ __html: brand.config.footerNote }} />
    </>
  );
}

// Phone Number Formatting
function formatPhoneInput(value) {
  if (/[xX]/.test(value)) {
    return value.replace(/[^\d\s+\-().xX]/g, "");
  }
  const hasPlus = value.trim().startsWith("+");
  const digitsOnly = value.replace(/\D/g, "");
  const raw = (hasPlus ? "+" : "") + digitsOnly;
  return new AsYouType("US").input(raw);
}

function getCursorPosAfterFormat(formattedValue, digitsBeforeCursor) {
  let count = 0;
  for (let i = 0; i < formattedValue.length; i++) {
    if (/\d/.test(formattedValue[i])) {
      count++;
      if (count === digitsBeforeCursor) return i + 1;
    }
  }
  return formattedValue.length;
}

// ─── Verify Screen ────────────────────────────────────────────────────────────
function VerifyScreen({ onVerified, onGoBack, worker, brand }) {

  const queryParams = new URLSearchParams(window.location.search);
  const letterIdParam = !!queryParams.get("l") ? queryParams.get("l") : queryParams.get("letter");
  const amountParam = !!queryParams.get("a") ? queryParams.get("a") : queryParams.get("amount");
  const nameParam = !!queryParams.get("n") ? queryParams.get("n") : queryParams.get("name");
  const [form, setForm] = useState({ claimId: !!letterIdParam ? letterIdParam : "", amount: !!amountParam ? amountParam.replace(/[^\d.]/g, '') : "", name: !!nameParam ? nameParam: "", phone: "", email: "" });
  const [errors, setErrors] = useState({});
  const [turnstile, setTurnstile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");
  const TURNSTILE_SITE_KEY = worker.getCfTurnstileSitekey();

  const set = (key, val) => setForm((p) => ({ ...p, [key]: val }));

  const displayFieldHintForCashAndName = () => {
    if (!amountParam && !!nameParam) {
      return "Enter the amount exactly as printed on the letter. Do not include the $ symbol.";
    }
    else if (!amountParam && !nameParam) {
      return "Enter the name and amount exactly as printed on the letter. Do not include the $ symbol.";
    }
  }

  const handlePhoneChange = (e) => {
    const input = e.target;
    const cursorPos = input.selectionStart;
    const digitsBeforeCursor = input.value.slice(0, cursorPos).replace(/\D/g, "").length;
    const formatted = formatPhoneInput(input.value);
    set("phone", formatted);
    requestAnimationFrame(() => {
      const newPos = getCursorPosAfterFormat(formatted, digitsBeforeCursor);
      input.setSelectionRange(newPos, newPos);
    });
  };

  const validate = () => {
    const e = {};
    if (!form.claimId.trim()) e.claimId = "Letter ID is required.";
    else if (!/^[A-Z0-9-]{4,20}$/i.test(form.claimId.trim())) e.claimId = "Enter the Letter ID exactly as shown on your letter.";
    if (!form.amount.trim()) e.amount = "Amount is required.";
    else if (isNaN(parseFloat(form.amount)) || parseFloat(form.amount) <= 0) e.amount = "Enter a valid dollar amount (e.g. 120.00).";
    if (!form.amount.trim()) e.amount = "A dollar amount is required.";
    else if (isNaN(parseFloat(form.amount)) || parseFloat(form.amount) <= 0) e.amount = "Enter a valid dollar amount.";
    if (!form.name.trim()) e.name = "Last name is required.";
    else if (form.name.trim().length < 2) e.name = "Please enter at least 2 characters.";
    if (!form.phone.trim()) e.phone = "Phone number is required.";
    else if (!/[xX]/.test(form.phone) && !isValidPhoneNumber(form.phone.trim(), "US")) e.phone = "Enter a valid phone number.";
    if (!form.email.trim()) e.email = "Email address is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) e.email = "Enter a valid email address.";
    return e;
  };

  const handleSubmit = async () => {
    const e = validate();
    setErrors(e);
    setApiError("");
    if (Object.keys(e).length > 0) {
      if (e.phone || e.email) {
        trackVirtualEvent("/error/verify/missing-contact-info");
      }
      return;
    }
    if (!turnstile) {
       setApiError("Please confirm you are a human.");
         trackVirtualEvent("/error/verify/turnstile-not-completed");
        return; 
      }
    // Reset captcha after failed API call so user can retry

    setLoading(true);
    try {
      const result = await verifyClaim(form.claimId, form.amount, form.name, worker, turnstile);
      if (!result.ok) {
        console.log("[UPCR] Setting error:", result.message);
        setApiError(result.message);
      }
      else onVerified({ ...result, phone: form.phone, email: form.email, enteredAmount: form.amount.trim() });
    } catch {
      setApiError("A network error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <StepIndicator current={2} />
      <div className="section-title">Letter Verification</div>
      <p style={{ fontSize: 13, color: "var(--gray-700)", marginBottom: "1.1rem", lineHeight: 1.5 }}>
        Enter the information exactly as it appears on your due diligence letter.
      </p>

     

      <div className="field">
        <label>Letter ID <span style={{ color: "var(--red)" }}>*</span></label>
        <input
          type="text" placeholder="e.g. GL-AB-123-45"
          value={form.claimId}
          className={errors.claimId ? "error" : ""}
          onChange={(e) => set("claimId", e.target.value)}
          autoCapitalize="characters"
          autoComplete="off"
          disabled={!!letterIdParam}
        />
        {errors.claimId && <div className="field-error">{errors.claimId}</div>}
        <div className="field-hint">
  {letterIdParam
    ? "Your Letter Id - can not be changed"
    : 'Found on your due diligence letter, labeled "Letter ID" or "Reference Number".'}
</div>
 </div>
      <div className="field-row">
        <div className="field" style={{ marginBottom: 0 }}>
          <label> Amount <span style={{ color: "var(--red)" }}>*</span></label>
          <input
            type="number" placeholder="e.g. 250.00" min="0" step="0.01"
            value={form.amount}
            className={errors.amount ? "error" : ""}
            onChange={(e) => set("amount", e.target.value)}
            inputMode="decimal"
            disabled={!!amountParam}
          />
          {errors.amount && <div className="field-error">{errors.amount}</div>}
          <div className="field-hint">
            {amountParam
              ? "The amount on record - can not be changed"
              : "If multiple properties are listed, enter any dollar amount associated with a property."}
          </div>
        </div>
        <div className="field" style={{ marginBottom: 0 }}>
          <label>Last Name <span style={{ color: "var(--red)" }}>*</span></label>
          <input
            type="text" placeholder="e.g. Smith or Acme Corp"
            value={form.name}
            className={errors.name ? "error" : ""}
            onChange={(e) => set("name", e.target.value)}
            autoComplete="family-name"
            disabled={!!nameParam}
          />
          {errors.name && <div className="field-error">{errors.name}</div>}
          <div className="field-hint" style={{ marginTop: 4, marginBottom: "1rem" }}>
            {!!nameParam
              ? "The name on our record - can not be changed"
              : !nameParam && !amountParam ? "" : "Enter the name exactly as printed on the letter."}
          </div>
        </div>
      </div>
      <div className="field-hint" style={{ marginTop: 4, marginBottom: "1rem" }}>{displayFieldHintForCashAndName()}</div>
    

      <hr />
      <div className="section-title">Contact Information <span style={{ fontWeight: 400, textTransform: "none", fontSize: 10, color: "var(--gray-500)" }}>(required)</span></div>

      <div className="field-row">
        <div className="field" style={{ marginBottom: 0 }}>
          <label>Phone Number <span style={{ color: "var(--red)" }}>*</span></label>
          <input
            type="tel" placeholder="e.g. (555) 123-4567"
            value={form.phone}
            className={errors.phone ? "error" : ""}
            onChange={handlePhoneChange}
            autoComplete="tel"
            inputMode="tel"
          />
          {errors.phone && <div className="field-error">{errors.phone}</div>}
          <div className="field-hint" style={{ fontSize: 9.5 }}>Outside US? Add country code, e.g. +44 20 7946 0958</div>
        </div>
        <div className="field" style={{ marginBottom: 0 }}>
          <label>Email Address <span style={{ color: "var(--red)" }}>*</span></label>
          <input
            type="email" placeholder="e.g. you@example.com"
            value={form.email}
            className={errors.email ? "error" : ""}
            onChange={(e) => set("email", e.target.value)}
            autoComplete="email"
            inputMode="email"
          />
          {errors.email && <div className="field-error">{errors.email}</div>}
        </div>
      </div>
      <div className="field-hint" style={{ marginTop: 4, marginBottom: "1rem" }}>{brand.config.contactHint}</div>

      <div style={{ display: "flex", justifyContent: "center", margin: "0.5rem 0 1rem" }}>
        <Turnstile siteKey={TURNSTILE_SITE_KEY} 
          onSuccess={(token) => setTurnstile(token)}
          onExpire={() => setTurnstile(null)}
          onTimeout={() => setTurnstile(null)}
          onError={() => setTurnstile(null)}
          options = {{theme: brand.config.turnstileTheme || "light", appearance: "always"}}/>
      </div> 

      {apiError && (
        <div className="alert alert-error">
          <span className="alert-icon">⚠</span>
          <span>{apiError}</span>
        </div>
      )}
      <button className="btn-primary" onClick={handleSubmit} disabled={loading | !turnstile}>
        {loading ? <><span className="spinner" />Verifying…</> : "Verify & Continue →"}
      </button>

      <div className="btn-back-wrap">
        <button className="btn-back" onClick={onGoBack}>← Back</button>
      </div>

      <p className="footer-note" style={{ marginTop: "0.75rem" }}>
        Your information is transmitted securely and used only to verify your claim record.
      </p>

     
    </>
  );
}
// ─── Confirm Screen ───────────────────────────────────────────────────────────
function ConfirmScreen({ claimData, onSuccess, onGoBack, worker, brand }) {
  const [loading, setLoading] = useState(false);
  const [turnstile, setTurnstile] = useState(null);
  const [apiError, setApiError] = useState("");
  const [sigName, setSigName] = useState("");
  const [sigError, setSigError] = useState("");
  const [responseChoice, setResponseChoice] = useState("");
  const [claimSelected, setClaimSelected] = useState(false);
  const [responseError, setResponseError] = useState("");
  const [addrErrors, setAddrErrors] = useState({});
  const [confirmChecked, setConfirmChecked] = useState(false);
  const [confirmCheckError, setConfirmCheckError] = useState("");
  const [comments, setComments] = useState("");
  const [letterImage, setLetterImage] = useState(null);
  const [letterImageError, setLetterImageError] = useState("");
  const [addr, setAddr] = useState({ line1: "", line2: "", line3: "", city: "", state: "", zip: "", country: "United States" });
  const sigDate = new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  const TURNSTILE_SITE_KEY = worker.getCfTurnstileSitekey();
  const setA = (key, val) => setAddr(p => ({ ...p, [key]: val }));

  const validateAddr = () => {
    const e = {};
    if (!addr.line1.trim()) e.line1 = "Address Line 1 is required.";
    if (!addr.city.trim()) e.city = "City is required.";
    if (!addr.state.trim()) e.state = "State is required.";
    if (!addr.zip.trim()) e.zip = "ZIP / Postal Code is required.";
    else if (!/^[0-9A-Z\s-]{3,10}$/i.test(addr.zip.trim())) e.zip = "Enter a valid ZIP or postal code.";
    return e;
  };

  const formattedNewAddr = [addr.line1, addr.line2, addr.line3, addr.city && addr.state ? addr.city + ", " + addr.state : addr.city || addr.state, addr.zip, addr.country !== "United States" ? addr.country : ""].filter(Boolean).join(" · ");

const letterImageColors = brand.config.letterImageUpload?.required
  ? brand.config.letterImageUpload?.colorsRequired
  : brand.config.letterImageUpload?.colorsOptional;

const handleLetterImageChange = (e) => {
  const file = e.target.files[0];
  if (!file) { setLetterImage(null); setLetterImageError(""); return; }

  const allowedTypes = ["image/png", "image/jpeg", "application/pdf"];
  const allowedExtension = /\.(png|jpe?g|pdf)$/i;
  const maxSizeMB = brand.config.letterImageUpload?.maxSizeMB || 20;
  const maxSizeBytes = maxSizeMB * 1024 * 1024;

  if (!allowedTypes.includes(file.type) && !allowedExtension.test(file.name)) {
    setLetterImageError("Please upload a PNG, JPG, or PDF file. The file type uploaded is not accepted.");
    e.target.value = "";
    setLetterImage(null);
    return;
  }

  if (file.size > maxSizeBytes) {
    setLetterImageError(`File is too large. Please upload a file smaller than ${maxSizeMB}MB.`);
    e.target.value = "";
    setLetterImage(null);
    return;
  }

  setLetterImage(file);
  setLetterImageError("");
};

    const handleSubmit = async () => {
    setLoading(true);
    setApiError("");
    if (!turnstile) { setApiError("Please confirm you are a human."); 
      trackVirtualEvent("/error/submit/turnstile-not-completed");
      return; 

    }
    try {
      // Generate PDF blob first
      let pdfBlob = null;
      try {
        pdfBlob = await generateAndPostSubmissionPDF(
          { ...claimData, comments: comments.trim() || null },
          "PENDING",
          responseChoice,
          sigName.trim(),
          responseChoice === "update_address"
            ? { line1: addr.line1, line2: addr.line2, line3: addr.line3, city: addr.city, state: addr.state, zip: addr.zip, country: addr.country }
            : null,
          new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" }),
          brand.config
        );
      } catch (pdfErr) {
        console.error("[UPCR] PDF generation failed:", pdfErr);
      }

      const enrichedPayload = {
        ...claimData,
        responseChoice,
        signerName:    sigName.trim(),
        comments:      comments.trim() || null,
        phone:         claimData.phone || claimData.phone || null,
        email:         claimData.email || claimData.email || null,
        pdfBlob, letterImage,
        updatedAddress: responseChoice === "update_address"
          ? { line1: addr.line1, line2: addr.line2, line3: addr.line3, city: addr.city, state: addr.state, zip: addr.zip, country: addr.country }
          : null,
      };

      const result = await submitClaim(enrichedPayload, worker, turnstile);
      if (result.ok) {
        onSuccess(result.referenceNumber);
      } else {
        setApiError(result.message);
      }
    } catch {
      setApiError("A network error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitWithSig = async () => {
    if (!responseChoice) {
      setResponseError(
        claimSelected
          ? "Please select whether your information is correct or you need to update your address."
          : "Please select a response before signing."
      );
      return;
    }
    if (responseChoice === "update_address") {
      const ae = validateAddr();
      setAddrErrors(ae);
      if (Object.keys(ae).length > 0) {
        trackVirtualEvent("/error/submit/incomplete-update-address");
        return;
      }
    }

    if (brand.config.letterImageUpload?.required && !letterImage) {
  setLetterImageError("Please attach a photo of your letter to continue.");
  return;
}
setLetterImageError("");

   if (!confirmChecked) {
  setConfirmCheckError("You must confirm the details above before signing.");
  trackVirtualEvent("/error/submit/confirmation-not-checked");
  return;
}
    if (!sigName.trim() || sigName.trim().length < 2) {
  setSigError("Please type your full legal name to sign.");
  trackVirtualEvent("/error/submit/not-signed");
  return;
}
    setSigError(""); setResponseError(""); setConfirmCheckError("");
    handleSubmit();
  };

  return (
    <>
      <StepIndicator current={3} />
      <div className="section-title">Review &amp; Submit</div>
      <p style={{ fontSize: 13, color: "var(--gray-700)", marginBottom: "1rem", lineHeight: 1.5 }}>
        Please review the details below. Confirm they are correct before signing and submitting your claim response.
      </p>

    
      {/* Header info — name, address, letter ID */}
      <div className="summary-box" style={{ marginBottom: "1rem" }}>
        <div className="summary-row">
  <span className="summary-label">Letter ID</span>
  <span className="summary-value" style={{ fontFamily: "monospace", fontSize: "1.08em" }}>{claimData.claimId}</span>
</div>
{claimData.company && (
  <div className="summary-row">
    <span className="summary-label">Company Name</span>
    <span className="summary-value">{claimData.company}</span>
  </div>
)}
<div className="summary-row">
  <span className="summary-label">Full Name on Record</span>
          <span className="summary-value">{claimData.fullName || claimData.holderName}</span>
        </div>
        <div className="summary-row">
          <span className="summary-label">Address on Record</span>
          <span className="summary-value">{claimData.address}</span>
        </div>
      </div>

      {/* Property cards */}
      {claimData.properties && claimData.properties.length > 0 && (
        <>
          <div className="section-title" style={{ marginTop: "0.25rem" }}>
            {claimData.properties.length === 1 ? "Property Detail" : `Properties (${claimData.properties.length})`}
          </div>
          <div className="property-cards">
            {claimData.properties.map((prop, i) => (
              <div className="property-card" key={prop.id || i}>
              <div className="property-card-header">Property {claimData.properties.length > 1 ? i + 1 : ""}</div>
              <div className="summary-row">
                    <span className="summary-label">Item ID</span>
                    <span className="summary-value">{prop.id || "—"}</span>
                </div>
                <div className="summary-row">
                  <span className="summary-label">Issue Date</span>
                  <span className="summary-value">{prop.issue_date || "—"}</span>
            </div>
            <div className="summary-row">
                  <span className="summary-label">Amount</span>
                  <span className="summary-value" style={{ color: "var(--brand-dark)", fontWeight: 600 }}>
                   ${parseFloat(prop.amount).toFixed(2)}
                 </span>
            </div>
            
{prop.account_number && (
  <div className="summary-row">
    <span className="summary-label">Account Number</span>
    <span className="summary-value">{prop.account_number}</span>
  </div>
)}
{prop.transaction_number && (
  <div className="summary-row">
    <span className="summary-label">Transaction Number</span>
    <span className="summary-value">{prop.transaction_number}</span>
  </div>
)}

            <div className="summary-row">
                 <span className="summary-label">Description</span>
                  <span className="summary-value">{prop.description || "—"}</span>
            </div>
              </div>
            ))}
          </div>
          {claimData.properties.length > 1 && (
            <div className="property-total-row">
              <span className="property-total-label">Total Amount</span>
              <span className="property-total-value">
                ${claimData.properties.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0).toFixed(2)}
              </span>
            </div>
          )}
        </>
      )}

      <hr />
      <div className="section-title">Please Indicate Your Response</div>

<div className="section-title" style={{ marginTop: "0.75rem" }}>Submit a Claim</div>

      <div className="response-options">
  <div
    className={"response-option" + (claimSelected ? " selected" : "")}
    onClick={() => { setClaimSelected(true); setResponseChoice(""); setResponseError(""); setConfirmChecked(false); setConfirmCheckError(""); }}
    role="radio"
    aria-checked={claimSelected}
    tabIndex={0}
    onKeyDown={(e) => e.key === "Enter" && setClaimSelected(true)}
  >
    <div className={"response-radio" + (claimSelected ? " selected" : "")} />
    <span className="response-label">I am the owner, and I would like to submit a claim for the funds detailed above</span>
  </div>
</div>
{responseError && claimSelected && !responseChoice && (
  <div className="field-error" style={{ marginTop: 4 }}>{responseError}</div>
)}

{claimSelected && (
  <>
    <div className="section-title" style={{ marginTop: "0.75rem" }}>Confirm Your Address</div>
    <div className="summary-box" style={{ marginBottom: "0.75rem" }}>
      <div className="summary-row">
        <span className="summary-label">Name on Record</span>
        <span className="summary-value">{claimData.fullName || claimData.holderName}</span>
      </div>
      <div className="summary-row">
        <span className="summary-label">Address on Record</span>
        <span className="summary-value">{claimData.address}</span>
      </div>
    </div>
    <div className="response-options">
      {[
        { value: "confirmed",      label: "The information displayed above is correct" },
        { value: "update_address", label: "I need to update my address" },
      ].map(({ value, label }) => (
        <div
          key={value}
          className={"response-option" + (responseChoice === value ? " selected" : "")}
          onClick={() => { setResponseChoice(value); setResponseError(""); setConfirmChecked(false); setConfirmCheckError(""); }}
          role="radio"
          aria-checked={responseChoice === value}
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && setResponseChoice(value)}
        >
          <div className={"response-radio" + (responseChoice === value ? " selected" : "")} />
          <span className="response-label">{label}</span>
        </div>
      ))}
    </div>
  </>
)}

      {responseChoice === "confirmed" && (
        <div className="alert alert-success" style={{ marginTop: "0.85rem" }}>
          <span className="alert-icon">✉</span>
          <span>A check may be reissued to resolve this property. Please review your details below and complete the attestation to proceed.</span>
        </div>
      )}
      {responseChoice === "update_address" && (
        <div className="alert alert-info" style={{ marginTop: "0.85rem" }}>
          <span className="alert-icon">📬</span>
          <span>A check may be reissued to your updated address. Please enter your new mailing address below, confirm the details are correct, and complete the attestation to proceed.</span>
        </div>
      )}

      {responseChoice === "update_address" && (
        <>
          <hr style={{ marginTop: "1.25rem" }} />
          <div className="section-title">New Mailing Address</div>
          <p style={{ fontSize: 12.5, color: "var(--gray-500)", marginBottom: "1rem", lineHeight: 1.5 }}>
            Please enter the address where a reissued check should be mailed.
          </p>
          <div className="field">
            <label>Address Line 1 <span style={{ color: "var(--red)" }}>*</span></label>
            <input type="text" placeholder="Street number and name" value={addr.line1}
              className={addrErrors.line1 ? "error" : ""}
              onChange={e => { setA("line1", e.target.value); setAddrErrors(p => ({ ...p, line1: "" })); }}
              autoComplete="address-line1" />
            {addrErrors.line1 && <div className="field-error">{addrErrors.line1}</div>}
          </div>
          <div className="field">
            <label>Address Line 2 <span style={{ fontSize: 10, color: "var(--gray-500)", fontWeight: 400 }}>(optional)</span></label>
            <input type="text" placeholder="Apt, Suite, Unit, etc." value={addr.line2}
              onChange={e => setA("line2", e.target.value)}
              autoComplete="address-line2" />
          </div>
          <div className="field">
            <label>Address Line 3 <span style={{ fontSize: 10, color: "var(--gray-500)", fontWeight: 400 }}>(optional)</span></label>
            <input type="text" placeholder="Building, floor, or additional info" value={addr.line3}
              onChange={e => setA("line3", e.target.value)} />
          </div>
          <div className="field-row">
            <div className="field" style={{ marginBottom: 0 }}>
              <label>City <span style={{ color: "var(--red)" }}>*</span></label>
              <input type="text" placeholder="City" value={addr.city}
                className={addrErrors.city ? "error" : ""}
                onChange={e => { setA("city", e.target.value); setAddrErrors(p => ({ ...p, city: "" })); }}
                autoComplete="address-level2" />
              {addrErrors.city && <div className="field-error">{addrErrors.city}</div>}
            </div>
            <div className="field" style={{ marginBottom: 0 }}>
              <label>State / Province <span style={{ color: "var(--red)" }}>*</span></label>
              <input type="text" placeholder="e.g. CA" value={addr.state}
                className={addrErrors.state ? "error" : ""}
                onChange={e => { setA("state", e.target.value); setAddrErrors(p => ({ ...p, state: "" })); }}
                autoComplete="address-level1" />
              {addrErrors.state && <div className="field-error">{addrErrors.state}</div>}
            </div>
          </div>
          <div className="field-row" style={{ marginTop: "0.75rem" }}>
            <div className="field" style={{ marginBottom: 0 }}>
              <label>ZIP / Postal Code <span style={{ color: "var(--red)" }}>*</span></label>
              <input type="text" placeholder="e.g. 90210" value={addr.zip}
                className={addrErrors.zip ? "error" : ""}
                onChange={e => { setA("zip", e.target.value); setAddrErrors(p => ({ ...p, zip: "" })); }}
                autoComplete="postal-code" inputMode="numeric" />
              {addrErrors.zip && <div className="field-error">{addrErrors.zip}</div>}
            </div>
            <div className="field" style={{ marginBottom: 0 }}>
              <label>Country</label>
              <input type="text" placeholder="United States" value={addr.country}
                onChange={e => setA("country", e.target.value)}
                autoComplete="country-name" />
            </div>
          </div>

          {formattedNewAddr && (
            <>
              <hr style={{ marginTop: "1.25rem" }} />
              <div className="section-title">Updated Address Summary</div>
              <div className="summary-box" style={{ marginBottom: "1rem" }}>
                <div className="summary-row">
                  <span className="summary-label">Name on Record</span>
                  <span className="summary-value">{claimData.fullName || claimData.holderName}</span>
                </div>
                <div className="summary-row">
                  <span className="summary-label">New Mailing Address</span>
                  <span className="summary-value" style={{ color: "var(--brand-dark)", fontWeight: 600 }}>{formattedNewAddr}</span>
                </div>
              </div>
           </>
          )}
        </>
      )}


      

{!claimSelected && (
  <>
    <div className="response-divider"><span>OR</span></div>
    <div className="section-title">Do Not Claim The Funds Detailed Above</div>

    <div className="response-options">
      {[
        { value: "not_holder", label: "I am not the owner indicated in the letter" },
        { value: "not_owed",   label: "I am the owner indicated in the letter but I am not owed these funds" },
      ].map(({ value, label }) => (
        <div
          key={value}
          className={"response-option" + (responseChoice === value ? " selected" : "")}
          onClick={() => { setClaimSelected(false); setResponseChoice(value); setResponseError(""); setConfirmChecked(false); setConfirmCheckError(""); }}
          role="radio"
          aria-checked={responseChoice === value}
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && setResponseChoice(value)}
        >
          <div className={"response-radio" + (responseChoice === value ? " selected" : "")} />
          <span className="response-label">{label}</span>
        </div>
      ))}
      {responseError && !claimSelected && <div className="field-error" style={{ marginTop: 4 }}>{responseError}</div>}
    </div>
  </>
)}

     

{(brand.config.letterImageUpload?.enabled ?? true) && responseChoice && (
  <>
    <hr style={{ marginTop: "1.25rem" }} />
    <div className="section-title">
      {brand.config.letterImageUpload?.sectionTitle || "Photograph Your Letter"}
      <span style={{ fontWeight: 400, textTransform: "none", fontSize: 10, color: "var(--gray-500)" }}>
        {" "}({brand.config.letterImageUpload?.required ? "required" : "optional"})
      </span>
    </div>
    <p style={{ fontSize: 12, color: "var(--gray-500)", fontStyle: "italic", marginBottom: "0.75rem", lineHeight: 1.5 }}>
      {brand.config.letterImageUpload?.hintText || "You're welcome to attach a photo of your letter."}
    </p>
    <div className="field">
      <label>
        Letter Image {brand.config.letterImageUpload?.required && <span style={{ color: "var(--red)" }}>*</span>}
      </label>
     <div
  className="file-upload-wrap"
  style={{
    "--file-upload-bg": letterImageColors?.background,
    "--file-upload-border": letterImageColors?.border,
    "--file-upload-text": letterImageColors?.text,
    "--file-upload-hover-bg": letterImageColors?.hoverBackground,
    "--file-upload-hover-border": letterImageColors?.hoverBorder,
  }}
>
        <input
          type="file"
          id="letter-image-input"
          className="file-upload-input"
          accept=".png,.jpg,.jpeg,.pdf,image/png,image/jpeg,application/pdf"
          capture="environment"
          onChange={handleLetterImageChange}
        />
       <label
  htmlFor="letter-image-input"
  className={"file-upload-btn" + (brand.config.letterImageUpload?.required ? " required" : "")}
>
  <svg className="file-upload-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 8.5C4 7.67157 4.67157 7 5.5 7H7.5L8.70711 5.29289C8.89464 5.10536 9.14899 5 9.41421 5H14.5858C14.851 5 15.1054 5.10536 15.2929 5.29289L16.5 7H18.5C19.3284 7 20 7.67157 20 8.5V17.5C20 18.3284 19.3284 19 18.5 19H5.5C4.67157 19 4 18.3284 4 17.5V8.5Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"/>
    <circle cx="12" cy="13" r="3.25" stroke="currentColor" strokeWidth="1.7"/>
  </svg>
  {letterImage
    ? (brand.config.letterImageUpload?.buttonTextSelected || "Retake or Choose a Different Photo")
    : (brand.config.letterImageUpload?.buttonText || "Take or Choose a Photo")}
</label>
      </div>
      {letterImage && <div className="file-upload-filename">✓ {letterImage.name}</div>}
      {letterImageError && <div className="field-error">{letterImageError}</div>}
    </div>
  </>
)}



      {responseChoice && (
  <>
    <hr style={{ marginTop: "1.25rem" }} />
    <div className="section-title">Additional Comments <span style={{ fontWeight: 400, textTransform: "none", fontSize: 10, color: "var(--gray-500)" }}>(optional)</span></div>

<div className="field">
  <textarea
    className="comments-input"
    placeholder="Include any additional details or context relevant to your response..."
    value={comments}
    onChange={(e) => setComments(e.target.value)}
    rows={3}
  />
  <div className="field-hint">This will be included with your submission record.</div>
</div>

<hr style={{ marginTop: "1.25rem" }} />
<div className="section-title">Digital Attestation &amp; Signature</div>
<div className="sig-attest-box">
  <p className="sig-attest-text">
    By signing below, I, the undersigned, attest that I am the individual or authorized legal representative of the individual named above, and that the response selected above is truthful, accurate, and complete to the best of my knowledge.
  </p>
  <p className="sig-attest-warning">
    ⚠ <strong>Warning:</strong> Submitting a fraudulent claim for unclaimed property belonging to another individual may constitute fraud and is subject to civil and criminal penalties under applicable state and federal law, including fines and imprisonment.
  </p>
  <div className="sig-field-wrap">
              <label className="sig-label">Type your full legal name to sign <span style={{ color: "var(--red)" }}>*</span></label>
              <input
                className={"sig-input" + (sigError ? " error" : "")}
                type="text"
                placeholder="Full legal name"
                value={sigName}
                onChange={(e) => { setSigName(e.target.value); if (sigError) setSigError(""); }}
                autoComplete="name"
              />
              {sigError && <div className="field-error">{sigError}</div>}
            </div>
            {sigName.trim().length >= 2 && (
              <div className="sig-preview">
                <span className="sig-cursive">{sigName.trim()}</span>
                <span className="sig-date">{sigDate}</span>
              </div>
            )}

            {responseChoice && (
              <>
                <div
                  className={"confirm-check-row" + (confirmCheckError ? " error" : "")}
                  onClick={() => { setConfirmChecked(p => !p); setConfirmCheckError(""); }}
                  role="checkbox"
                  aria-checked={confirmChecked}
                  tabIndex={0}
                  onKeyDown={e => e.key === " " && (e.preventDefault(), setConfirmChecked(p => !p))}
                  style={{ marginTop: 14 }}
                >
                  <div className={"confirm-checkbox" + (confirmChecked ? " checked" : "")}>{confirmChecked && "✓"}</div>
                  <span className="confirm-check-label">
                    {responseChoice === "confirmed" &&
                      "I confirm that I am the rightful owner of the unclaimed property described above, that the property details shown are correct, and that my address on file is current and accurate."}
                    {responseChoice === "update_address" &&
                      "I confirm that I am the rightful owner of the unclaimed property described above, that the property details shown are correct, and that the new mailing address I have entered is accurate and should replace my address on record."}
                    {responseChoice === "not_holder" &&
                      "I confirm that I am not the owner indicated in this letter and my response above is truthful to the best of my knowledge."}
                    {responseChoice === "not_owed" &&
                      "I confirm that I am the owner indicated in this letter but I am not owed these funds, and my response above is truthful to the best of my knowledge."}
                  </span>
                </div>
                {confirmCheckError && <div className="field-error" style={{ marginTop: 4 }}>{confirmCheckError}</div>}
                {(responseChoice === "confirmed" || responseChoice === "update_address") && (
                  <p style={{ fontSize: 11.5, color: "var(--gray-500)", fontStyle: "italic", marginTop: 6, lineHeight: 1.5 }}>
                    By checking this box, you also agree to refund any amount received if you are later determined to not be the rightful owner of this property.
                  </p>
                )}
              </>
            )}
          </div>



 {apiError && (
            <div className="alert alert-error">
              <span className="alert-icon">⚠</span>
              <span>{apiError}</span>
            </div>
          )}

      <div style={{ display: "flex", justifyContent: "center", margin: "0.5rem 0 1rem" }}>
        <Turnstile siteKey={TURNSTILE_SITE_KEY} 
          onSuccess={(token) => setTurnstile(token)}
          onExpire={() => setTurnstile(null)}
          onTimeout={() => setTurnstile(null)}
          onError={() => setTurnstile(null)}
          options = {{theme: brand.config.turnstileTheme || "light", appearance: "always"}}/>
      </div> 

          <button className="btn-primary" onClick={handleSubmitWithSig} disabled={loading || !turnstile}>
            {loading ? <><span className="spinner" />Submitting…</> : "Sign & Submit Claim Response"}
          </button>
          <div className="btn-back-wrap" style={{ marginTop: "0.75rem" }}>
            <button className="btn-back" onClick={onGoBack}>← Back to Verification</button>
          </div>
        </>
      )}
    </>
  );
}

// ─── Success Screen ───────────────────────────────────────────────────────────
function SuccessScreen({ refNum, claimData, brand }) {
  return (
    <>
      <div className="success-check-wrap">
        <div className="check-bubble">
          <svg className="check-svg" viewBox="0 0 36 36">
            <polyline className="check-path" points="6,18 14,26 30,10" />
          </svg>
        </div>
        <img src={brand.logo} alt="UPCR Logo" className="success-logo-small" />
      </div>
      <div className="success-title">Response Submitted</div>
      <div className="success-sub">
        Your due diligence response has been received and logged.
      </div>
      <div className="summary-box">
        <div className="summary-row">
          <span className="summary-label">Letter ID</span>
          <span className="summary-value" style={{ fontFamily: "monospace", fontSize: "1.08em" }}>{claimData.claimId}</span>
        </div>
        <div className="summary-row">
          <span className="summary-label">Properties</span>
          <span className="summary-value">{claimData.properties ? claimData.properties.length + " item(s)" : "—"}</span>
        </div>
        <div className="summary-row">
          <span className="summary-label">Name</span>
          <span className="summary-value">{claimData.holderName}</span>
        </div>
        <div className="summary-row">
          <span className="summary-label">Total Amount</span>
          <span className="summary-value">${claimData.properties ? claimData.properties.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0).toFixed(2) : "—"}</span>
        </div>
        {claimData.email && (
          <div className="summary-row">
            <span className="summary-label">Email</span>
            <span className="summary-value">{claimData.email}</span>
          </div>
        )}
      </div>
      <div className="alert alert-success">
        <span className="alert-icon">📬</span>
        <span>You will receive a confirmation via mail if contact information is on file.</span>
      </div>
      <p className="footer-note" dangerouslySetInnerHTML={{ __html: brand.config.footerNote }} />
    </>
  );
}


// ─── PDF Generation ───────────────────────────────────────────────────────────
async function generateAndPostSubmissionPDF(claimData, refNum, responseChoice, signerName, updatedAddress, sigDate, brandCfg) {
  try {
    const doc = new jsPDF({ unit: "pt", format: "letter" });
    const W      = doc.internal.pageSize.getWidth();
    const margin = 50;
    const col    = margin;
    let   y      = 0;

    const brand     = brandCfg.colors.brand;
    const brandDark = brandCfg.colors.brandDark;
    const gray9     = [26,  26,  24];
    const gray5     = [136, 135, 128];
    const white     = [255, 255, 255];

    const row = (label, value, yPos) => {
      doc.setFontSize(8).setFont("helvetica", "bold").setTextColor(...gray5);
      doc.text(label.toUpperCase(), col, yPos);
      doc.setFontSize(10).setFont("helvetica", "normal").setTextColor(...gray9);
      const lines = doc.splitTextToSize(String(value || "—"), W - margin - col - 10);
      doc.text(lines, W - margin, yPos, { align: "right" });
      doc.setDrawColor(235, 235, 230);
      doc.line(col, yPos + 6, W - margin, yPos + 6);
      return yPos + 22 + (lines.length - 1) * 12;
    };

    const sectionTitle = (title, yPos) => {
      doc.setFillColor(...brand);
      doc.roundedRect(col, yPos, W - margin * 2, 20, 3, 3, "F");
      doc.setFontSize(8).setFont("helvetica", "bold").setTextColor(...white);
      doc.text(title.toUpperCase(), col + 8, yPos + 13);
      return yPos + 30;
    };

    const checkPage = (yPos, needed = 60) => {
      if (yPos + needed > doc.internal.pageSize.getHeight() - margin) {
        doc.addPage();
        return margin;
      }
      return yPos;
    };

    // Header banner
    doc.setFillColor(...brand);
    doc.rect(0, 0, W, 70, "F");
    doc.setFontSize(22).setFont("helvetica", "bold").setTextColor(...white);
    doc.text(brandCfg.pdfHeaderLine1, margin, 32);
    doc.setFontSize(7.5).setFont("helvetica", "normal").setTextColor(200, 230, 210);
    doc.text(brandCfg.pdfHeaderLine2, margin, 45);
    doc.setFontSize(8).setFont("helvetica", "bold").setTextColor(...white);
    doc.text(brandCfg.pdfHeaderLine3, margin, 60);
    doc.setFontSize(9).setFont("helvetica", "bold").setTextColor(...white);
    doc.text("Letter ID: " + claimData.claimId, W - margin, 45, { align: "right" });    doc.setFontSize(8).setFont("helvetica", "normal").setTextColor(200, 230, 210);
    doc.text("Submitted: " + sigDate, W - margin, 58, { align: "right" });

    y = 90;

    // Section 1: Letter & Holder Information
   y = sectionTitle("Letter Information", y);
   y = row("Letter ID",       claimData.claimId,                         y); y = checkPage(y);
   y = row("Full Name",       claimData.fullName || claimData.holderName, y); y = checkPage(y);
   y = row("Address on File", claimData.address,                         y); y = checkPage(y);
   if (claimData.phone) { y = row("Phone", claimData.phone, y); y = checkPage(y); }
   if (claimData.email) { y = row("Email", claimData.email, y); y = checkPage(y); }
   if (claimData.company) { y = row("Company", claimData.company, y); y = checkPage(y); }

    y += 10;

    // Section 2: Properties
    y = checkPage(y, 40);
    y = sectionTitle("Properties", y);
    if (claimData.properties && claimData.properties.length > 0) {
      claimData.properties.forEach((prop, i) => {
        y = checkPage(y, 70);
        if (claimData.properties.length > 1) {
          doc.setFontSize(8).setFont("helvetica", "bold").setTextColor(...brandDark);
          doc.text("Property " + (i + 1), col, y);
          y += 14;
        }
       y = row("Item ID",    prop.id || "—",                              y); y = checkPage(y);
y = row("Issue Date", prop.issue_date || "—",                      y); y = checkPage(y);
y = row("Amount",     "$" + parseFloat(prop.amount).toFixed(2),   y); y = checkPage(y);
if (prop.account_number)     { y = row("Account Number",     prop.account_number,     y); y = checkPage(y); }
if (prop.transaction_number) { y = row("Transaction Number", prop.transaction_number, y); y = checkPage(y); }
if (prop.description)        { y = row("Description",        prop.description,        y); y = checkPage(y); }
        y += 4;
      });
      if (claimData.properties.length > 1) {
        const total = claimData.properties.reduce((s, p) => s + parseFloat(p.amount || 0), 0);
        doc.setFillColor(...brand);
        doc.roundedRect(col, y, W - margin * 2, 22, 3, 3, "F");
        doc.setFontSize(9).setFont("helvetica", "bold").setTextColor(...white);
        doc.text("TOTAL AMOUNT", col + 8, y + 14);
        doc.text("$" + total.toFixed(2), W - margin - 8, y + 14, { align: "right" });
        y += 32;
      }
    }

    y += 10;

   // Section 3: Response
    y = checkPage(y, 40);
    y = sectionTitle("Owner Response", y);
    const responseCategory = {
     confirmed:      "Submit a Claim",
     update_address: "Submit a Claim",
     not_holder:     "Do Not Claim The Funds Detailed Above",
     not_owed:       "Do Not Claim The Funds Detailed Above",
};
    const responseMain = {
     confirmed:      "I am the owner, and I would like to submit a claim for the funds detailed above",
     update_address: "I am the owner, and I would like to submit a claim for the funds detailed above",
     not_holder:     "I am not the owner indicated in the letter",
     not_owed:       "I am the owner indicated in the letter but I am not owed these funds",
};
    const responseSelection = {
     confirmed:      "The information displayed above is correct",
     update_address: "I need to update my address",
};
    y = row("Category", responseCategory[responseChoice] || "—", y); y = checkPage(y);
    y = row("Response", responseMain[responseChoice] || responseChoice, y); y = checkPage(y);
    if (responseSelection[responseChoice]) {
      y = row("Selection", responseSelection[responseChoice], y); y = checkPage(y);
    }

    if (responseChoice === "update_address" && updatedAddress) {
      const addrParts = [
        updatedAddress.line1, updatedAddress.line2, updatedAddress.line3,
        updatedAddress.city && updatedAddress.state ? updatedAddress.city + ", " + updatedAddress.state : updatedAddress.city || updatedAddress.state,
        updatedAddress.zip,
        updatedAddress.country !== "United States" ? updatedAddress.country : ""
      ].filter(Boolean).join(", ");
      y = row("Updated Mailing Address", addrParts, y); y = checkPage(y);
    }

    y += 10;

    // Section 3b: Additional Comments
    if (claimData.comments) {
      y = checkPage(y, 60);
      y = sectionTitle("Additional Comments", y);
      doc.setFontSize(10).setFont("helvetica", "normal").setTextColor(...gray9);
      const commentLines = doc.splitTextToSize(claimData.comments, W - margin * 2);
      doc.text(commentLines, col, y);
      y += commentLines.length * 13 + 10;
    }

    y += 10;

    // Section 4: Digital Attestation
    y = checkPage(y, 100);
    y = sectionTitle("Digital Attestation & Signature", y);
    doc.setFontSize(8.5).setFont("helvetica", "normal").setTextColor(...gray9);
    const attestText = "By signing below, I, the undersigned, attest that I am the individual or authorized legal representative of the individual named above, and that the response selected above is truthful, accurate, and complete to the best of my knowledge.";
    const attestLines = doc.splitTextToSize(attestText, W - margin * 2);
    doc.text(attestLines, col, y);
    y += attestLines.length * 12 + 16;

    y = checkPage(y, 60);
    doc.setDrawColor(...brand);
    doc.setLineWidth(1);
    doc.line(col, y, col + 220, y);
    doc.setFontSize(18).setFont("helvetica", "bolditalic").setTextColor(...brandDark);
    doc.text(signerName, col + 4, y - 6);
    doc.setFontSize(8).setFont("helvetica", "normal").setTextColor(...gray5);
    doc.text("Electronic Signature", col, y + 10);
    doc.text(sigDate, W - margin, y + 10, { align: "right" });

    y += 30;

    y = checkPage(y, 50);
    doc.setFillColor(253, 240, 239);
    doc.setDrawColor(229, 180, 177);
    doc.roundedRect(col, y, W - margin * 2, 36, 3, 3, "FD");
    doc.setFontSize(7.5).setFont("helvetica", "bold").setTextColor(122, 44, 44);
    doc.text("WARNING:", col + 8, y + 13);
    doc.setFont("helvetica", "normal");
    const warnLines = doc.splitTextToSize("Submitting a fraudulent claim for unclaimed property belonging to another individual may constitute fraud and is subject to civil and criminal penalties under applicable state and federal law.", W - margin * 2 - 16);
    doc.text(warnLines, col + 8, y + 24);

    doc.setFontSize(7.5).setFont("helvetica", "normal").setTextColor(...gray5);
    doc.text(brandCfg.pdfFooterText + " · Letter ID: " + claimData.claimId, W / 2, doc.internal.pageSize.getHeight() - 20, { align: "center" });
    // Attach PDF blob to submit payload
    const blob = doc.output("blob");
    console.log("[UPCR] PDF ready for " + refNum);
    return blob;

  } catch (err) {
    console.error("[UPCR] PDF generation/post failed:", err);
  }
}



// ─── App Root ─────────────────────────────────────────────────────────────────
export default function App() {
  const [brand, setBrand] = useState(null);
  const [screen, setScreen] = useState("welcome");
  const [claimData, setClaimData] = useState(null);
  const [refNum, setRefNum] = useState("");
  const [requestWorker, setRequestWorker] = useState(null);
  const [version] = useState("3.2.14");
  const [copywrite] = useState("2026 Copyright."); 
  const isPopStateNav = useRef(false);




  // Push a new history entry whenever the screen changes from in-app navigation
  useEffect(() => {
    if (isPopStateNav.current) {
      isPopStateNav.current = false;
      return;
    }

    // 1. Create a URL object from the current browser address
    const url = new URL(window.location.href);
    // 2. Safely change the path without stripping query params
    const virtualPath = "/" + screen ;
    url.pathname = virtualPath; 
    // 3. Push to the history stack 
    window.history.pushState({ screen }, "", url.toString());
  }, [screen]);




  // Sync screen state when the user presses browser back/forward
  useEffect(() => {
    const handlePopState = (event) => {
      if (event.state && event.state.screen) {
        isPopStateNav.current = true;
        setScreen(event.state.screen);
      }
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  useEffect(() => {
  const brandKey = getBrandKey();
  const basePath = `/whiteLabel/clients/${brandKey}/`;
  const fallbackPath = `/whiteLabel/clients/upcr/`;

  fetch(basePath + "config.json")
    .then(res => {
      if (!res.ok) throw new Error("Brand not found, falling back to upcr");
      return res.json().then(config => ({ config, path: basePath, key: brandKey }));
    })
    .catch(() =>
      fetch(fallbackPath + "config.json")
        .then(res => res.json())
        .then(config => ({ config, path: fallbackPath, key: "upcr" }))
    )
    .then(({ config, path, key }) => {
      const cssClass = "theme-" + (key === "dundermifflin" ? "dunder" : key);

      const existingLink = document.getElementById("brand-theme-css");
      if (existingLink) existingLink.remove();
      const link = document.createElement("link");
      link.id = "brand-theme-css";
      link.rel = "stylesheet";
      link.href = path + "theme.css";
      document.head.appendChild(link);

      document.body.className = cssClass;

      setBrand({
        config,
        logo: path + config.logoFile,
        cssClass,
      });
    });
}, []);

  useEffect(() => {
    RequestWorker.init()
      .then(worker => setRequestWorker(worker))
      .catch(err => console.error("[UPCR] RequestWorker init failed:", err));
  }, []);

  if (!brand) {
    return <div style={{ padding: "2rem", textAlign: "center", fontFamily: "sans-serif" }}>Loading…</div>;
  }

  return (
    <>
      <style>{css}</style>
      <div className={"app-wrap " + brand.cssClass}>
        <div className="header">
          <div className="header-ghost" style={{ backgroundImage: `url(${brand.cssClass === "theme-upcr" ? UPCR_LOGO_GHOST : brand.logo})` }} />
          <div className="header-inner">
            <div className={brand.config.useHeaderTextBlock ? "header-text-block" : ""}>
              <div className="brand-name">{brand.config.brandName}</div>
              <div className="brand-tagline">{brand.config.tagline}</div>
             <div className="header-badge" dangerouslySetInnerHTML={{ __html: brand.config.badge }} />
            </div>
          </div>
        </div>
        <div className="card">
          {screen === "welcome" && <WelcomeScreen onBegin={() => setScreen("verify")} brand={brand} />}
          {screen === "verify" && (
            <VerifyScreen
              worker={requestWorker}
              brand={brand}
              onVerified={(data) => { setClaimData(data); setScreen("confirm"); }}
              onGoBack={() => setScreen("welcome")}
            />
          )}
          {screen === "confirm" && claimData && (
            <ConfirmScreen
              worker={requestWorker}
              claimData={claimData}
              brand={brand}
              onSuccess={(ref) => { setRefNum(ref); setScreen("success"); }}
              onGoBack={() => setScreen("verify")}
            />
          )}
          {screen === "success" && <SuccessScreen refNum={refNum} claimData={claimData} brand={brand} />}
          <div className="footer-note">&copy; {copywrite}&nbsp;&nbsp;{version}</div>
        </div>
      </div>
    </>
  );
}